import CalendarTodayIcon from "@mui/icons-material/CalendarTodayRounded";
import TagIcon from "@mui/icons-material/TagRounded";
import { Autocomplete, Box, ListItemIcon, ListItemText, TextField, Typography } from "@mui/material";
import type { DashboardFilter, DashboardFilterDataType } from "../../../dashboard.types";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";

interface Props {
  selectedFilter: DashboardFilter | null;
  filters: DashboardFilter[];
  onChange: (filter: DashboardFilter | null) => void;
}

const SelectedFilter = ({ selectedFilter, filters, onChange }: Props) => {
  return (
    <Autocomplete
      fullWidth
      renderValue={(value) => <Typography>{value?.caption}</Typography>}
      options={filters}
      getOptionLabel={(option) => option.caption}
      value={selectedFilter}
      onChange={(_, value) => onChange(value)}
      renderOption={({ key: _key, ...props }, option) => {
        return (
          <Box component="li" key={option.id} {...props}>
            <ListItemIcon>
              <FilterIcon dataType={option.dataType} />
            </ListItemIcon>
            <ListItemText>{option.caption}</ListItemText>
            <Typography variant="caption" color="textSecondary">
              {getUsedInWidgetsText(option)}
            </Typography>
          </Box>
        );
      }}
      renderInput={(params) => <TextField {...params} label="Select a filter" />}
    ></Autocomplete>
  );
};

export default SelectedFilter;

const FilterIcon = ({ dataType }: { dataType: DashboardFilterDataType }) => {
  switch (dataType) {
    case "date":
      return <CalendarTodayIcon color="secondary" />;
    default:
      return <TagIcon color="secondary" />;
  }
};

const getUsedInWidgetsText = (filter: DashboardFilter) => {
  return `${filter.widgets.length} ${pluralize("widget", filter.widgets.length)}`;
};
